import { axiosInstance as Axios } from "@/main";

export default {
  state: {
    location: {
      lat: 0,
      lng: 0
    },
    clinicSpecific: false,
    firstRender: true,
    windowWidth: 0,
    windowHeight: 0,
    organization: null,
    to: "",
    from: "",
    actual: "",
    search: "",
    session: "",
    urls: {
      politicaPrivacidadeLink: "https://solis2.quark.tec.br/public/privacidade/quarkclinic",
      termoUsoLink: "https://quarkk-wiki.atlassian.net/wiki/spaces/WIKI/pages/967507978/Termos+e+Condi+es+de+Uso"
    }
  },
  mutations: {
    set_clinicspecific(state, payload) {
      state.clinicSpecific = payload;
    },
    set_session(state, payload) {
      state.session = payload;
    },
    set_location(state, payload) {
      state.location = payload;
    },
    set_organization(state, payload) {
      state.organization = payload;
    },
    set_to(state, payload) {
      state.to = payload;
    },
    set_from(state, payload) {
      state.from = payload;
    },
    set_actual(state, payload) {
      state.actual = payload;
      state.search = "";
    },
    set_search(state, payload) {
      state.search = payload;
    },
    set_width(state, payload) {
      state.windowWidth = payload;
    },
    set_height(state, payload) {
      state.windowHeight = payload;
    },
    set_firstrender(state, payload) {
      state.firstRender = payload;
    },
    set_urls(state, payload) {
      state.urls = payload;
    }
  },
  actions: {
    set_clinicspecific(store, payload) {
      store.commit("set_clinicspecific", payload);
    },
    set_session(store, payload) {
      store.commit("set_session", payload);
    },
    async load_organization(store, { id }) {
      store.dispatch("load_logo_base64", { id });

      try {
        let { data } = await Axios.get("/geral/organizacao", {
          headers: { "X-Organizacao-ID": id }
        });

        store.commit("set_organization", data);
      } catch (e) {
        console.error("Erro ao carregar organização", e);
      }
    },
    set_to(store, payload) {
      store.commit("set_to", payload);
    },
    set_from(store, payload) {
      store.commit("set_from", payload);
    },
    set_actual(store, payload) {
      store.commit("set_actual", payload);
    },
    set_search(store, payload) {
      store.commit("set_search", payload);
    },
    set_width(store, payload) {
      store.commit("set_width", payload);
    },
    set_height(store, payload) {
      store.commit("set_height", payload);
    },
    set_firstrender(store, payload) {
      store.commit("set_firstrender", payload);
    },
    async sendLocation(store, payload) {
      store.commit("set_location", { ...payload });

      await Axios.post(
        "/configs/sessao/localizacao",
        { ...payload },
        {
          headers: { "X-Token-Sessao": this.session }
        }
      );
    },
    async load_urls(store) {
      let response = await Axios.get(`/geral/urls`);

      store.commit("set_urls", response.data);
    }
  },
  getters: {
    clinicSpecific(state) {
      return state.clinicSpecific;
    },
    get_organization(state) {
      return state.organization;
    },
    to(state) {
      return state.to;
    },
    from(state) {
      return state.from;
    },
    actual(state) {
      return state.actual;
    },
    search(state) {
      return state.search;
    },
    width(state) {
      return state.windowWidth;
    },
    height(state) {
      return state.windowHeight;
    },
    location(state) {
      return state.location;
    },
    first_render(state) {
      return state.firstRender;
    },
    session(state) {
      return state.session;
    },
    urls(state) {
      return state.urls;
    }
  }
};
